import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

export interface State {
  widgetPreviewLookupByAlias: WidgetPreviewLookupByAlias
  widgetPreviewLookupById: WidgetPreviewLookupById
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    widgetPreviewLookupByAlias: {},
    widgetPreviewLookupById: {},
  }
}

/**
 * Stores {@link ents.core.mosaic.Widget.Rendering} by
 * {@link ec.models.EntityId}
 *
 * @see {@link WidgetPreviewLookup.Entry}
 */
export type WidgetPreviewLookupById = Partial<
  Record<ec.models.EntityId, WidgetPreviewLookup.Entry>
>
/**
 * Stores {@link ents.core.mosaic.Widget.Rendering} by widget alias
 *
 * @see {@link WidgetPreviewLookup.Entry}
 */
export type WidgetPreviewLookupByAlias = Partial<
  Record<string, WidgetPreviewLookup.Entry>
>
export namespace WidgetPreviewLookup {
  /**
   * Represents a {@link ents.core.mosaic.Widget.Rendering}
   *
   * Since these are produced by an {@link ents.core.mosaic.Widget.Query}, it is
   * possible that the results are not correct. So this contains both the raw
   * results and, ideally, an actual {@link ents.core.mosaic.Widget.Rendering}
   */
  export interface Entry {
    rawPreview?: unknown
    preview?: ents.core.mosaic.Widget.Rendering
    isLoading?: boolean
    error?: Error
  }
}
